import type * as THREE from "three";
import { isLine } from "./isLine";
import { isMesh } from "./isMesh";

type MeshOrLine = THREE.Mesh | THREE.Line;

function isMeshOrLine(object: THREE.Object3D): object is MeshOrLine {
	return isMesh(object) || isLine(object);
}

export { isMeshOrLine, type MeshOrLine };
